const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_MY_TOPIC_SUCCESS: 'GET_MY_TOPIC_SUCCESS',
    GET_MY_TOPIC_ERROR: 'GET_MY_TOPIC_ERROR'
};

const header = ['タイトル', 'ワークスペース', 'ワークスペース', '対象', '作成日時', '更新日時', ''];
const table = [
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'Topicsタイトル'
            },
            {
                text: 'ワークスペース名'
            },
            {
                text: 'Game Topics'
            },
            {
                text: '8/3 巨人 - 中日'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                text: '2019/11/23 12:34'
            },
            {
                action: ['ワークスペースにコピー', '複製', '編集', '削除']
            }
        ]
    }
];
const listItemMyTopic = [
    'ゲームから作成',
    '球団から作成',
    '選手から作成'
];

const listdataCopy = [
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
    { name: 'ワークスペース名', active: false },
];

export default (state = {
    header, table, listItemMyTopic, listdataCopy
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_MY_TOPIC_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_ERROR:
        case ACTIONS.GET_MY_TOPIC_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};